import config from 'appConfig';
import superagent from 'superagent';

import DataParser from './parsers/DataParser';
import ErrorTypes from 'constants/ErrorTypes';

class DataSource {
	static getData(id, success, error) {
		const requestURL = `${config.API_HOST}${config.API_PATH}${id}`;
        // Create request
        const request = superagent.get(requestURL);

        // Send request
        request.end((err, res) => { 
            if (err) {
                console.log(err.status);
                error({
                    error: {
                        description: err.toString(),
                        type: ErrorTypes.ERROR_REQUEST_GET
                    }
                });                
            } else if (res.body.error) {
                error({
                    error: {
                        description: res.body.error,
                        type: ErrorTypes.ERROR_DATA_GET
                    }
                });
            } else {
                success({
                    data: DataParser.parse(res.body)
                });
            }
        });
    }

    static submitData(id, answers, success, error) {
		const requestURL = `${config.API_HOST}${config.API_PATH}${id}`;
     
        const data = {
            id: id,
            results: answers
        }
        
        superagent
            .post(requestURL)
            .send(data)
            .end((err, res) => {
                if (err) {
                    console.log(err.status);
                    error({
                        error: {
                            description: err.toString(),
                            type: ErrorTypes.ERROR_REQUEST_POST  
                        }
                    });               
                } else if (res.body.error) {
                    error({
                        error: {
                            description: res.body.error,
                            type: ErrorTypes.ERROR_DATA_POST
                        }
                    });
                } else {
                    success();
                }
            });
    }
}



export default DataSource;


/** WEBPACK FOOTER **
 ** ./src/sources/DataSource.js
 **/